import { useMutation } from "@tanstack/react-query";
import { archiveAthlete, type GetAthletesResponse } from "api-client";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from "ui";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  athlete: GetAthletesResponse["data"]["currentPage"][number];
  onSuccess: () => void;
}

export function ArchiveAthleteDialog(props: Props) {
  const { t } = useTranslation();

  const archiveAthleteMutation = useMutation({
    mutationFn: () => {
      return archiveAthlete({ path: { athleteId: props.athlete.id } });
    },
    onSuccess: () => {
      props.onSuccess();
      props.onOpenChange(false);
    },
  });

  return (
    <AlertDialog open={props.open} onOpenChange={props.onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("athletesPage.archiveDialog.title", {
              name: props.athlete.user.name,
            })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t("athletesPage.archiveDialog.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t("athletesPage.archiveDialog.cancel")}
          </AlertDialogCancel>
          <Button
            loading={archiveAthleteMutation.isPending}
            onClick={() => {
              archiveAthleteMutation.mutate();
            }}
          >
            {t("athletesPage.archiveDialog.confirm")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
